import React from "react";
import { useSelector } from "react-redux";
import { getCurrentStepLocked, getIsSubmitted } from "./selectors";
import { ColumnGrid } from "components/containers";
import { Form, useLookup } from "@redriver/cinnamon";
import TabLockedMessage from "./TabLockedMessage";
import { uniformSizesLookup } from "./lookups";

const yesNoOptions = [
  { value: "false", text: "No" },
  { value: "true", text: "Yes" },
];

const AdditionalInfoForm = () => {
  const isSubmitted = useSelector(getIsSubmitted);
  const isLocked = useSelector(getCurrentStepLocked);

  return (
    <ColumnGrid cols={2}>
      <ColumnGrid.Item>
        <Form.Dropdown
          field="drivingLicence"
          textField="drivingLicenceName"
          label="Driving Licence"
          fluid
          placeholder="Please select"
          required
          clearable
          disabled={isSubmitted || isLocked}
          options={yesNoOptions}
        />
      </ColumnGrid.Item>
      <ColumnGrid.Item>
        <Form.Dropdown
          field="uniformSize"
          textField="uniformSizeName"
          label="Uniform Size"
          fluid
          placeholder="Please select"
          required
          clearable
          disabled={isSubmitted || isLocked}
          lookup={uniformSizesLookup}
        />
      </ColumnGrid.Item>
      <ColumnGrid.Item>
        <Form.Input
          field="nextOfKin"
          label="Next of Kin"
          fluid
          required
          disabled={isSubmitted || isLocked}
        />
      </ColumnGrid.Item>
      <ColumnGrid.Item>
        <Form.Input
          field="nextOfKinContact"
          label="Next of Kin Contact Number"
          fluid
          required
          disabled={isSubmitted || isLocked}
        />
      </ColumnGrid.Item>
      <ColumnGrid.Item>
        <Form.Input
          field="nextOfKinRelationship"
          label="Next of Kin Relationship"
          fluid
          required
          disabled={isSubmitted || isLocked}
        />
      </ColumnGrid.Item>

      {isLocked && (
        <ColumnGrid.Item colsWidth={2}>
          <TabLockedMessage />
        </ColumnGrid.Item>
      )}
    </ColumnGrid>
  );
};

export default AdditionalInfoForm;
